import axios from "../../utils/axios";
import { API_SUFFIX } from "../../config/app";

// 获取巡查团队列表
export function apiXteamlistList(query) {
    return axios({
        url: "/admin/index/x_teamlist" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 验证 团队ID 是否唯一
export function isItemNumberID(query) {
    return axios({
        url: '/admin/index/item_number',
        method: "get",
        params: query
    });
}

// 新巡查团队
export function apiAddXteamSave(data, formName, method = "post") {
    var url =
        formName === "addTeam"
            ? "/admin/index/addx_team" + API_SUFFIX
            : formName === "addTeamUser"
                ? "/admin/index/addx_teamuser" + API_SUFFIX
                : formName === "editTeamUser"
                    ? "/admin/index/x_useredit" + API_SUFFIX
                    : "";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// 获取巡查团队详情
export function apiXteamdetailsList(query) {
    return axios({
        url: "/admin/index/x_teamdetails" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 新增巡查队员
export function apiAddxTeamuser(data, method = "post") {
    return axios({
        url: "/admin/index/addx_teamuser" + API_SUFFIX,
        method: method,
        data: data
    });
}


// 获取编辑巡查队员 信息
export function apiXuserEditData(query) {
    return axios({
        url: "/admin/index/x_useredit" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 提交编辑巡查队员 信息
export function apiXuserEdit(data, method = "post") {
    return axios({
        url: "/admin/index/x_useredit" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 删除巡查队员
// export function apiXuserDelete(query) {
//     return axios({
//         url: "/admin/index/x_delete" + API_SUFFIX,
//         method: "get",
//         params: query
//     });
// }
export function apiXuserDelete(data, method = "post") {
    return axios({
        url: "/admin/index/x_delete" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 重置密码 GET
export function apiResetPassword(query) {
    return axios({
        url: "/admin/index/reset_password" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 获取编辑巡查团队 信息
export function apiXceditTeamEditData(query) {
    return axios({
        url: "/admin/index/xcedit" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 编辑巡查团队信息 提交
export function apiXceditTeamEditSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/xcedit" + API_SUFFIX,
        method: method,
        data: data
    });
}